var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-main"},[_c('ProfileCard',_vm._g({attrs:{"user":_vm.user,"followers":_vm.followers}},_vm.$listeners)),_c('ProfileTabs',{attrs:{"status":_vm.status}}),_c('UserTweetsPosts',_vm._g({attrs:{"tweets":_vm.tweets},on:{"after-create-reply-modal":_vm.afterCreateReplyModal}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }